import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import * as actions from "../../../../../redux/timeline/actions";
import { getActiveProject } from "../../../../../redux/projects";
import {
  createTimelineEvent,
  isCreatingEvent,
  getActiveEvent,
  updateTimelineEvent,
  isUpdatingEvent,
} from "../../../../../redux/timeline";

import type TimelineEventCollection from "../../models/TimelineEventCollection";
import type TimelineEvent from "../../models/TimelineEvent";
import type User from "../../models/User";
import type Project from "../../models/Project";

import EventForm from "../../../../../components/forms/timeline-event-form/TimelineEventForm";
import EventFormUpdate from "../../../../../components/forms/timeline-event-form-update/TimelineEventFormUpdate";

import { Redirect, Link } from "react-router-dom";

type Props = {
  user: ?User,
  onModalClose: () => void,
  project: Project,
  event: TimelineEvent,
  defaultTimelineEvents: TimelineEventCollection,
};

type StateProps = {
  activeProject: ?Project,
  isCreatingEvent: boolean,
  isUpdatingEvent: boolean,
  activeEvent: ?TimelineEvent,
};

type State = {
  eventId: ?string,
  eventName: ?string,
  eventDate: ?string,
  timezone: ?string,
};

class EventModal extends Component {
  props: Props;
  state: State = {
    eventId: null,
    eventName: null,
    eventDate: null,
    timezone: null,
  };
  createEventPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <Modal.Dialog>
          {this.props.event != null
            ? this.renderUpdateEventForm()
            : this.renderEventForm()}
        </Modal.Dialog>
      </div>
    );
  }

  renderEventForm() {
    return (
      <div>
        <Modal.Header>
          <Modal.Title>New Timeline Item</Modal.Title>
        </Modal.Header>
        <EventForm
          createTimelineEvent={this.props.createTimelineEvent}
          onDidCreateTimelineEvent={this.props.onModalClose}
          user={this.props.user}
          onModalClose={this.props.onModalClose}
          projectId={this.props.activeProject.id}
          projectDate={this.props.activeProject.date}
          defaultTimelineEvents={this.props.defaultTimelineEvents}
        />
      </div>
    );
  }

  //TODO add spinner to indicate loading after update clicked
  renderUpdateEventForm() {
    return (
      <div>
        <Modal.Header>
          <Modal.Title>Update Timeline Item</Modal.Title>
        </Modal.Header>
        <EventFormUpdate
          updateTimelineEvent={this.props.updateTimelineEvent}
          onDidUpdateTimelineEvent={() => {
            this.props.onModalClose();
            this.props.collapseEvent();
          }}
          user={this.props.user}
          onModalClose={this.props.onModalClose}
          projectId={this.props.activeProject.id}
          event={this.props.event}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activeProject: getActiveProject(state),
    isCreatingEvent: isCreatingEvent(state),
    isUpdatingEvent: isUpdatingEvent(state),
    activeEvent: getActiveEvent(state),
  };
};

export default connect(mapStateToProps, actions)(EventModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/event-modal/EventModal.js